import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert,
} from '@mui/material';

const DrBill = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Ask Dr. Bill
      </Typography>
      <Paper
        sx={{
          position: 'relative',
          p: 2,
          height: 'calc(100vh - 200px)',
          maxHeight: '90%',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              zIndex: 10,
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <iframe
          src="https://drbillai.com/"
          title="Dr. Bill AI"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          onLoad={() => setLoading(false)}
          sandbox="allow-same-origin allow-scripts allow-forms"
        />
      </Paper>
    </Box>
  );
};

export default DrBill;